export default __webpack_public_path__ + "static/media/favorite.c6bb8d62.svg";